import { defineMessages } from 'react-intl';

export const declineCompleteIntl = defineMessages({
  h1: {
    id: '23a6341d32d9e6fd9a27e7aef8fca76ef2e147ab59e22b42f033ad37dc6a1c86',
    description:
      'text in modal of signer flow, when signer declines the signature request, the document as an signature request will close',
    defaultMessage: 'This document is now closed.',
  },
  h2: {
    id: '3d8d88c50ddb0596b158ae3f2510e8457f42e4654c9fe15b78660155d8dc6a5b',
    description:
      'text in modal of signer flow, informing signer will receive the confirmation of declining of signature request',
    defaultMessage: "You'll receive an email confirmation shortly.",
  },
  close: {
    id: 'd1628cf5a4a7a31376b5bc2f91e55cfac37c5720caa19cfa80e04433588a650e',
    description: 'button text of iFrame , clicking will close iFrame',
    defaultMessage: 'Close',
  },
});
